module.exports = __webpack_public_path__ + "media/images/lb/314-6b0d1053dcebed166513082a3725d20e.svg";